// Constants
import { WIDTH_MENU_POINT } from '@src/common/constants/point';

const HALF_WIDTH_MENU_POINT = WIDTH_MENU_POINT / 2;

export const calcPointMenuPosition = (width: number): number => width / 2 - HALF_WIDTH_MENU_POINT;
